import React, { Component } from "react";
import { Select, MenuItem, withStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { loadLandlordAnnouncements, handleAnnouncementSelection } from "../../actions/landlordActions";
import { capitalize } from "../../actions/utils";
import { RESIDENCE_TYPES } from "../../constants";
import "./PropertySelection.css";

const styles = {
    icon: {
        color: "#060825"
    },
    root: {
        fontSize: "1.5rem",
        color: "#060825"
    }
}

class PropertySelection extends Component {

    componentDidMount() {
        this.props.loadAnnouncements();
    }

    translateResidenceType = ( residenceType ) => {
        if ( !residenceType )
            return "";
        let result = ""
        if ( typeof residenceType === "string" )
            result = [RESIDENCE_TYPES.find(item => item.value === residenceType)]
        if (result === "")
            result = residenceType
            .map(type => RESIDENCE_TYPES.find(item => item.value === type))
        result = result.map(type => type ? type.displayName : undefined)
            .filter(Boolean)
            .join(", ")
        return result;
    }

    render() {
        const { classes, selection, announcements, onSelect } = this.props;
        return (
            <Select
                classes={classes}
                value={selection}
                onChange={(event, element) => {console.log(event.target.value);return onSelect(event.target.value)}}
            >
                <MenuItem color= 'secondary'disabled value="">Select your property</MenuItem>
                {announcements.map( ( v, i ) => {
                    console.log('property selector',v)
                    return (
                        <MenuItem key={v.id} value={v.id}>
                            <span className={v.isActive ? "" : "PropertySelection-inactive"}>
                                { `${capitalize( v.properties.address )}`}
                            </span>
                        </MenuItem>
                    );
                } )}
            </Select>
        );
    }

}

function mapStateToProps( state, ownProps ) {
    return {
        selection: state.landlord.selectedAnnouncement,
        announcements: state.landlord.announcements
    }
}

function mapDispatchToProps( dispatch, ownProps ) {
    return {
        onSelect: ( id ) => dispatch( handleAnnouncementSelection( id ) ),
        loadAnnouncements: () => dispatch( loadLandlordAnnouncements() )
    }
}

PropertySelection = withStyles( styles )( PropertySelection );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( PropertySelection );